import request from "@/utils/request";
import qs from "qs";

import axios from "axios";

/**
 * 获取用户IM Sign
 *
 */
export function getUserSign() {
  return request({
    url: `api/v3/teacher_hybrid/user_im_sign`,
    method: "get",
  });
}

/**
 * 发送抖音消息（会同时同步到IM）
 */
export function sendMsg(params) {
  return request({
    url: `api/v3/teacher_hybrid/send_message`,
    method: "post",
    params: params,
  });
}

/**
 * 发送抖音主动授权消息（会同时同步到IM）
 */
export function sendAuthMsg(params) {
  return request({
    url: `api/v3/teacher_hybrid/send_auth_message`,
    method: "post",
    params: params,
  });
}

/**
 * 发送抖音群消息（会同时同步到IM）
 */
export function sendGroupMsg(params) {
  return request({
    url: `api/v3/teacher_hybrid/send_group_message`,
    method: "post",
    params: params,
  });
}

/**
 * 创建消息卡片
 */
export function createCard(params) {
  return request({
    url: `api/v3/teacher_hybrid/douyin/createCard`,
    method: "post",
    params: params,
  });
}

/**
 * 获取抖音Scheme链接
 */
export function getUrlLink(params) {
  return request({
    url: `api/v3/teacher_hybrid/douyin/getUrlLink`,
    method: "post",
    params: params,
  });
}

/**
 * 创建抖音群聊
 */
export function createGroup(params) {
  return request({
    url: `api/v3/teacher_hybrid/douyin/group_create`,
    method: "post",
    params: params,
  });
}

/**
 * 加载群列表
 */
export function getGroupList() {
  return request({
    url: `api/v3/teacher_hybrid/douyin/group_list`,
    method: "get",
  });
}

/**
 * 粉丝群定制
 */
export function setGroupStatus(groupId, params) {
  return request({
    url: `api/v3/teacher_hybrid/douyin/${groupId}/set_group_status`,
    method: "post",
    params: params,
  });
}

/**
 * 小程序应用素材上传
 */
export function uploadXcxImage(file) {
  let param = new FormData();
  param.append("file", file);
  const config = {
    headers: { "Content-Type": "multipart/form-data" },
  };
  return request.post(
    "api/v3/teacher_hybrid/douyin/xcx_img_upload",
    param,
    config
  );
}

/**
 * Web应用素材上传
 */
export function uploadWebImage(file) {
  let param = new FormData();
  param.append("file", file);
  const config = {
    headers: { "Content-Type": "multipart/form-data" },
  };
  return request.post(
    "api/v3/teacher_hybrid/douyin/upload_web_img",
    param,
    config
  );
}

/**
 * 进群申请列表
 */
export function getApplyList(params) {
  return request({
    url: `api/v3/teacher_hybrid/douyin/group_myapply_list`,
    method: "get",
    params: params,
  });
}

/**
 * 进群审核
 */
export function applyAudit(params) {
  return request({
    url: `api/v3/teacher_hybrid/douyin/group_apply_audit`,
    method: "post",
    params: params,
  });
}

/**
 * 获取剩余群个数
 */
export function getGroupCount(params) {
  return request({
    url: "/api/v3/teacher_hybrid/douyin/group_count",
    method: "get",
    params,
  });
}

/**
 * 查询自动回复列表
 */
export function getReplyList(groupId, params) {
  return request({
    url: `api/v3/teacher_hybrid/${groupId}/find_reply_list`,
    method: "get",
    params: params,
  });
}

/**
 * 创建自动回复
 */
export function createReply(params) {
  return request({
    url: `api/v3/teacher_hybrid/create_reply`,
    method: "post",
    params: params,
  });
}

/**
 * 修改自动回复
 */
export function updateReply(replyId, params) {
  return request({
    url: `api/v3/teacher_hybrid/${replyId}/update_reply`,
    method: "post",
    params: params,
  });
}

/**
 * 删除自动回复
 */
export function deleteReply(replyId) {
  return request({
    url: `api/v3/teacher_hybrid/${replyId}/delete_reply`,
    method: "post",
  });
}

/**
 * Webapp授权
 */
export function findWebappAuth() {
  return request({
    url: `api/v3/teacher_hybrid/douyin/webapp/find_auth`,
    method: "get",
  });
}

/**
 * Webapp授权换取Token
 */
export function requestWebappAuth(code) {
  return request({
    url: `api/v3/teacher_hybrid/douyin/webapp/auth`,
    method: "post",
    params: { code },
  });
}

/**
 * 小程序授权
 */
export function findXcxAuth() {
  return request({
    url: `api/v3/teacher_hybrid/douyin/xcx/find_auth`,
    method: "get",
  });
}

/**
 * 小程序授权
 */
export function applyScopes(scopes) {
  return request({
    url: `api/v3/teacher_hybrid/douyin/xcx/req_scopes`,
    method: "post",
    params: { scopes: scopes },
  });
}

/**
 * 短视频列表
 */
export function findVideoList(params) {
  return request({
    url: `api/v3/teacher_hybrid/douyin/get_video_list`,
    method: "get",
    params,
  });
}

/**
 * 获取群聊授权码
 */
export function findGroupAuthCode(params) {
  return request({
    url: `api/v3/teacher_hybrid/douyin/group_auth_code`,
    method: "post",
    params: params,
  });
}

/**
 * 获取抖音视频链接
 */
export function findVideoLink(params) {
  return request({
    url: `api/v3/teacher_hybrid/douyin/get_video_link`,
    method: "get",
    params: params,
  });
}

/**
 * 生成教学资料发送码
 */
export function createPrivateMessage(params) {
  return request({
    url: `api/v3/teacher_hybrid/douyin/create_private_message`,
    method: "post",
    params: params,
  });
}

/**
 * 生成教学资料发送码
 */
export function groupRelative(data) {
  return request({
    url: `api/v3/teacher_hybrid/douyin/group_relative`,
    method: "post",
    data: qs.stringify(data),
  });
}

export function getUserSig(data) {
  return axios.get(`https://sqy.renrenjiang.cn/api/v4/live/genUserSig`, {
    params: data,
  });
}
